import { Code, Database, LayoutDashboard, Play, Users, type LucideIcon } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { isNavItemActive } from '@/lib/navigation';
import type { NavIcon, NavItem } from '@/lib/types';

const iconMap: Record<NavIcon, LucideIcon> = {
  LayoutDashboard,
  Database,
  Code,
  Play,
  Users,
};

interface NavigationListProps {
  items: NavItem[];
  activePath: string;
  listClassName: string;
  linkClassName: string;
  activeClassName: string;
  collapsed?: boolean;
  onNavigate?: () => void;
}

export default function NavigationList({
  items,
  activePath,
  listClassName,
  linkClassName,
  activeClassName,
  collapsed = false,
  onNavigate,
}: NavigationListProps) {
  return (
    <ul className={listClassName}>
      {items.map((item) => {
        const Icon = iconMap[item.icon];
        const active = isNavItemActive(activePath, item.path);
        return (
          <li key={item.path}>
            <NavLink
              to={item.path}
              className={`${linkClassName}${active ? ` ${activeClassName}` : ''}`}
              aria-current={active ? 'page' : undefined}
              aria-label={collapsed ? item.label : undefined}
              title={collapsed ? item.label : undefined}
              onClick={onNavigate}
            >
              <Icon size={18} aria-hidden="true" />
              {!collapsed && <span>{item.label}</span>}
            </NavLink>
          </li>
        );
      })}
    </ul>
  );
}
